export enum CustomerCancelReason {
  NoBank = 'no_bank',
  ChangedMind = 'changed_mind',
  PaymentButtonNotWorking = 'payment_button_not_working',
  RequisitesNotFilled = 'requisites_not_filled',
  QrNotWorking = 'qr_not_working',
  BankPaymentRejected = 'bank_payment_rejected',
}
